import React, { useEffect, useState } from 'react';

import { useMutation, useQuery } from '@tanstack/react-query';

import useSessionStorage from '../../../App/Component/useSessionStorage';
import LoadingAnim from '../../../Assessments/Components/loadingAnim';
import { useResponsive } from '../../../RiverusUI/Components/ResponsiveProvider';
import { getBrowserInfo } from '../../../Search/Components/helper';
import {
  getIPAddress,
  getProfile,
  trackLogin,
} from '../../../Services/authApi';
import { fetchNegativeListConfig } from '../../../Services/NegativeList';
import { fetchPartyConfig } from '../../../Services/PartyMaster';
import { fetchProductConfig } from '../../../Services/ProductMaster';
import { fetchLabel } from '../../../Services/ProjectConfig';
import { fetchTatEmailConfig } from '../../../Services/tat';
import { fetchTerritoryConfig } from '../../../Services/TerritoryMaster';

const UserAuthChecker = (ComposedClass: any) => {
  const AuthenticationCheck = (props: any) => {
    const [userProfile, serUserProfile] =
      useSessionStorage<any>('user_profile');
    const [, setUserId] = useSessionStorage<any>('user_id');
    const [, setUserName] = useSessionStorage<any>('user_name');

    const [kcRealm] = useSessionStorage<any>('kcRealm');
    const [, setProjectLabel] = useSessionStorage<any>('project_label');
    const [, setProjectConfig] = useSessionStorage<any>('project_config');
    const [, setProductConfig] = useSessionStorage<any>('product_config');
    const [, setTerritoryConfig] = useSessionStorage<any>('territory_config');
    const [, setPartyConfig] = useSessionStorage<any>('party_config');
    const [, setNegativeListConfig] = useSessionStorage<any>(
      'negative_list_config'
    );
    const [, setTatEmailConfig] = useSessionStorage<any>('tat_email_config');
    const [loading, setLoading] = useState(false);

    const { isMobile, isTablet, isLaptop, isDesktop, device } = useResponsive();

    const { mutate: trackLoginMutation } = useMutation({
      mutationKey: ['track_login'],
      mutationFn: trackLogin,
    });

    const { mutate: getIPAddressMutation } = useMutation({
      mutationKey: ['getIPAddress'],
      mutationFn: getIPAddress,
      onSuccess: (response: any) => {
        if (response?.client_ip) {
          trackLoginMutation({
            ip_address: response?.client_ip,
            device: {
              isMobile,
              isDesktop,
              isLaptop,
              isTablet,
              device,
              ...getBrowserInfo(),
            },
          });
        } else {
          trackLoginMutation({
            ip_address: 'Not Fetched',
            device: {
              isMobile,
              isDesktop,
              isLaptop,
              isTablet,
              device,
              ...getBrowserInfo(),
            },
          });
        }
      },
      onError: () => {
        trackLoginMutation({
          ip_address: 'Not Fetched',
          device: {
            isMobile,
            isDesktop,
            isLaptop,
            isTablet,
            device,
            ...getBrowserInfo(),
          },
        });
      },
    });

    const { data: projectData } = useQuery({
      queryKey: ['get_project_label'],
      queryFn: fetchLabel,
      select: (response: any) => response,
    });

    useEffect(() => {
      if (projectData) {
        setProjectLabel(projectData?.name);
        setProjectConfig(projectData);
      }
    }, [projectData]);

    const { data: partyData } = useQuery({
      queryKey: ['get_party_config'],
      queryFn: fetchPartyConfig,
      select: (response: any) => response,
    });

    useEffect(() => {
      if (partyData) {
        setPartyConfig(partyData);
      }
    }, [partyData]);

    // const { data: negativeListData } = useQuery({
    //   queryKey: ['get_negative_list_config'],
    //   queryFn: fetchNegativeListConfig,
    //   select: (response: any) => response,
    // });

    // useEffect(() => {
    //   if (negativeListData) {
    //     setNegativeListConfig(negativeListData);
    //   }
    // }, [negativeListData]);

    const { data: tatEmailData } = useQuery({
      queryKey: ['get_tat_email_config'],
      queryFn: fetchTatEmailConfig,
      select: (response: any) => response,
    });

    useEffect(() => {
      if (tatEmailData) {
        setTatEmailConfig(tatEmailData);
      }
    }, [tatEmailData]);

    const { data: productData } = useQuery({
      queryKey: ['get_product_config'],
      queryFn: fetchProductConfig,
      select: (response: any) => response,
    });

    const { data: territoryData } = useQuery({
      queryKey: ['get_territory_config'],
      queryFn: fetchTerritoryConfig,
      select: (response: any) => response,
    });

    useEffect(() => {
      if (productData) {
        setProductConfig(productData);
      }
    }, [productData]);

    useEffect(() => {
      if (territoryData) {
        setTerritoryConfig(territoryData);
      }
    }, [territoryData]);

    useQuery({
      queryKey: ['profile'],
      queryFn: async () => {
        setLoading(true);
        const response = await getProfile();

        if (response) {
          const profile = response as any;

          serUserProfile(profile);
          setUserId(profile.id);
          setUserName(`${profile.first_name} ${profile.last_name}`);
          if (kcRealm === 'HDBFS' || kcRealm === 'hdbfsrcpstg') {
            trackLoginMutation({
              ip_address: '0.0.0.0',
              device: {
                isMobile,
                isDesktop,
                isLaptop,
                isTablet,
                device,
                ...getBrowserInfo(),
              },
            });
          } else {
            getIPAddressMutation();
          }
          setLoading(false);
        }
      },
      enabled: !userProfile,
    });

    if (loading) {
      return <LoadingAnim />;
    } else return <ComposedClass {...props} />;
  };

  return AuthenticationCheck;
};

export default UserAuthChecker;
